import { render, staticRenderFns } from "./mtaccountList.vue?vue&type=template&id=587e3cbf&scoped=true"
import script from "./mtaccountList.vue?vue&type=script&lang=js"
export * from "./mtaccountList.vue?vue&type=script&lang=js"
import style0 from "./mtaccountList.vue?vue&type=style&index=0&id=587e3cbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e3cbf",
  null
  
)

export default component.exports